import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

export default function GTMWrapper({ children, organizationData }) {
  const googleTagManagerId = organizationData?.config?.website?.gtmId
  useEffect(() => {
    if (googleTagManagerId) {
      TagManager.initialize({
        gtmId: googleTagManagerId, // for client
      })
    }
  }, [googleTagManagerId])

  return children
}
